export default "__VITE_ASSET__BtTUt2OD__"